import { Row, Col, Card, Typography, Spin, Tabs } from "antd";
import { Skeleton, Switch, Avatar,Menu } from 'antd';
import Slider from 'react-slick';
import "../Pages/desktop.css";
import React, { useEffect, useState } from "react";
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { useParams } from "react-router";
import moment from "moment";
import { Header } from "antd/lib/layout/layout";
const { Meta } = Card;
const { Text, Link } = Typography;


const { TabPane } = Tabs;

function callback(key) {
    console.log(key);
  }


const FixturesVerticle = () => {
    const {id} = useParams();
    const [loading, setLoading] = useState(true);
    const [fixtures, setFixtures] = useState(null);
    const [complete, setComplete] = useState(null);
    const TodayDate = moment(new Date()).format("DD MMM YYYY, dddd");
   
    useEffect(() => {
        if(loading == true){
            fetch('https://api.arynews.tv/sports/apiTxt/cricApi.php?q=completeMatches')
            .then(response => response.json())
            .then(data => {
                setComplete(data.data.reverse());
                // alert(data);
                fetch('https://api.arynews.tv/sports/apiTxt/cricApi.php?q=scheduleMatches')
                .then(response => response.json())
                .then(data => {
                    setFixtures(data);
                    // alert(data);
                    setLoading(false)
                    
                });
            });

        
        }
        
    });
    
    return(
        <>
            <Tabs defaultActiveKey="1" style={{ padding: 5}} onChange={callback}>
                <TabPane tab="Upcomming Matches" key="1">
                {loading == false ? 
                <Row>
                    
                    
                                
                        
                                {fixtures.data.map(( item, key ) => 
                            
                                <Card
                                className="customCardWidth"
                                        style={{ width: '100%', margin: 5 }}
                                        
                                        title= {item.date_wise == TodayDate ? <span className="todayMatchChip">Today</span> : item.date_wise}
                                        extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.match_time.replace('30', '00')}</span>} style={{ width: 300 }}
                                        >
                                    
                                        <Row>
                                            <Col span={24}>
                                            
                                                <Meta
                                            avatar={
                                                <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_a_short.toLowerCase()+'.svg'} />
                                                
                                            }
                                            title={item.team_a}
                                        
                                            
                                            />
                                            
                                                <Meta
                                            avatar={
                                                <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_b_short.toLowerCase()+'.svg'} />
                                                
                                            }
                                            title={item.team_b}
                                            extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.time}</span>} style={{ width: 300 }}
                                            />  
                                        
                                        
                                            </Col>
                                            <Col className="statdium" style={{marginTop: 5,color:'black'}} span={24}>
                                            {item.venue}
                                            </Col>
                                        </Row>
                                            

                                                                        
                                    
                                    </Card>
                                
                                    
                                
                            )}
                            </Row>
                        :<div className="centLoading">
                        <Spin size="large" />
                    </div>}
                </TabPane>
                <TabPane tab="Completed Matches" key="2">
                {loading == false ? 
                <Row>
                    
                    
                                {complete.map(( item, key ) => 
                            
                            (key < 40 ? 
                            <Card className="customCardWidth"

                            style={{ width: '100%', margin: 5 }}
                            
                            title= {item.date_wise}
                            extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.match_time.replace('30', '00')}</span>} style={{ width: 300 }}
                            >
                            
                            <Row>
                                <Col span={24}>
                                    
                                    <Meta
                                avatar={
                                    <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_a_short.toLowerCase()+'.svg'} />
                                    
                                }
                                title={<div>{item.team_a} <span className="resultsChip">{item.team_a_scores}</span></div>}
                                
                                />
                                    
                                    <Meta
                                avatar={
                                    <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_b_short.toLowerCase()+'.svg'} />
                                    
                                }
                                title={<div>{item.team_b} <span className="resultsChip">{item.team_b_scores}</span></div>}
                                extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.time}</span>} style={{ width: 300 }}
                                />  
                            
                                
                                </Col>
                                <Col className="statdium" style={{marginTop: 5,color:'black'}} span={24}>
                                    <div className="resultFinal">{item.result.replace('wkts','wickets')}<a class="linkScorecard" href={'/match/'+item.match_id}> Scorecard </a></div>

                                </Col>
                            </Row>
                                

                                                            
                            
                        </Card> : <div></div>)
                            
                                
                                
                        )}
                        
                                
                            </Row>
                        :<div className="centLoading">
                        <Spin size="large" />
                    </div>}
                </TabPane>
            </Tabs>
            
        
        </>       
        
    );
}

export default FixturesVerticle;